const FilledCircleCheckedIcon = props => (
	<svg
		className="filled-circle-checked-icon"
		width="15"
		height="15"
		viewBox="0 0 15 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx="7" cy="7.92773" r="7" fill="currentColor" />
		<path
			d="M6.16504 9.36265L3.67605 7.08108L2.97534 7.81344L6.16504 10.8274L10.9753 5.79975L10.2746 5.06738L6.16504 9.36265Z"
			fill="white"
		/>
		<defs>
			<clipPath id="clip0_2050_11899">
				<rect width="8" height="8" fill="white" transform="translate(3 3.92773)" />
			</clipPath>
		</defs>
	</svg>
);

export default FilledCircleCheckedIcon;
